<template>
  <div id="companymainroute">
    <div class="headertrial-bgc">
      <div class="header-shadow">
        <CompanyHeader :title="''" ref="companyHeaderRef" @companyPercenterClick="companyPercenterClick">
            <template slot="message-tip" v-if="isHasMessageMenu">
              <div :class="badgeValue?'ismessagehot':''" class="ismessagediv" @click="goMessageCenterPage">
                <i class="iconfont icon-xiaoxitishi" style="font-size:20px;" ></i>
                <span class="word-message" style="font-size:12px;margin-left:5px">消息</span> 
              </div> 
            </template>
        </CompanyHeader>
      </div>
      <div style="margin-top:50px;color:#fff;text-align:center;font-size:22px">个人中心</div>
    </div>
    <el-row
      type="flex"
      justify="center"
      class="content"
      v-loading="pageloading"
      :element-loading-text="mainroteLoadingText"
    >
      <el-col
        :xs="22"
        :sm="22"
        :md="22"
        :lg="20"
        :xl="18"
        style="min-height: 100%;margin-top:-84px"
      >
        <el-container style="height: 100%;" v-if="isRouterShow">
          <!-- 侧边栏 -->
          <el-aside style="width:230px;overflow-x:hidden;border-radius:2px">
            <CompanySideBar ref="companysidebar" @menuReady="menuReady">
                <template slot="subadmin-select" v-if="options.length && options.length!=1">
                  <div style="background:#fff;padding:10px 0px 17px 0px;">
                    <el-tooltip
                        placement="top"
                        :disabled="disabletoolContent"
                        :content="getcompanynamevalue(subcompanyvalue)">   
                      <el-select v-model="subcompanyvalue" placeholder=""
                            style="width:100%"
                            class="companyselect-wraper"
                            popper-class="companypopper-class" 
                            :popper-append-to-body="false"
                            @change="sunadminChange"
                            >
                                <el-option
                                v-for="item in options"
                                :key="item.enterpriseId"
                                :label="item.enterpriseName"
                                :value="item.enterpriseId">
                                  <el-tooltip
                                              placement="top"
                                              :disabled="item.enterpriseName.length<13"
                                            >
                                                <div slot="content">
                                                    <span>{{item.enterpriseName}}</span>
                                                </div>
                                                <div style="width:180px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ item.enterpriseName }}</div>
                                      </el-tooltip>
                                </el-option>
                      </el-select>
                    </el-tooltip>
                  </div>
                </template>
            </CompanySideBar>
          </el-aside>
          <el-main style="background:#fff;padding:0px;margin:20px 0px 0px 20px">
             <keep-alive >
              <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive "></router-view>
          </el-main>
          <div>
            <CallAndFeedback></CallAndFeedback>
          </div>
        </el-container>
      </el-col>
    </el-row>
    <Footer></Footer>
  </div>
</template>

<script>
import CompanyHeader from '@/view/CompanyUser/companyHeader'
import Footer from '../../components/Footer'
import CompanySideBar from '@/view/CompanyUser/CompanySideBar'
import CallAndFeedback from '@/view/CompanyUser/CallAndFeedback'
import head_pic from '@/assets/head_pic.png'
import {GetEnterpriseSelectedListApi} from '@/js/enterPriseApi.js'
import {getMessageListApi} from '@/js/sprint5meetingAndMessage'
import {GetMenuListApi} from '@/js/Api/PermissionApi.js'
import Bus from '@/js/bus'
export default {
  name: 'companymainroute',
  components: {Footer, CompanySideBar,CallAndFeedback,CompanyHeader},
  data() {
    return {
      connection: null,
      head_pic,
      userId: '',
      user: '',
      ismobile: false,
      headSeeUrl:null,
      ismobileFooterHide: false,
      subcompanyvalue:'',
      options:[],
      isRouterShow:true,
      pageloading:false,
      mainroteLoadingText:'菜单权限获取中...',
      curentRoleSidebar:[],//保存一份当前角色的菜单
      disabletoolContent:true,
      isHasMessageMenu:false,
      badgeValue:0,
    }
  },
  computed: {
    
  },
  created() {
    //企业登录时候，默认已经到companycallback页面获取到所属企业id，并且设置enterpriseId存储和store存储 
    this.GetEnterpriseSelectedList()
  },
  mounted(){
    Bus.$on('updateBadgeVaule', params => {
        this.getBadgeValue()
    })
  },
  beforeDestroy(){
    Bus.$off('updateBadgeVaule',{})
  },
  methods: {
    menuReady(data){//判断是否显示消息提示的菜单，头部展示消息栏
      this.isHasMessageMenu=false
      if(Array.isArray(data)){
        data.forEach(item=>{
          if(item.name=='消息中心' && item.url=='/superadmin-message'){
            this.isHasMessageMenu=true
            this.getBadgeValue()
          }
        })
      }
    },
    getBadgeValue(){//获取消息的数量
        let that=this;
        getMessageListApi({
          pageIndex:1,
          pageSize:100
        })
        .then(res=>{
            console.log(res);
            if(res.status===200 && res.data.error_code===0){
                that.badgeValue=0;
                const {data}=res.data;
                if(data.hasOwnProperty('list')&&data.list.length>0){
                    data.list.forEach((item,index)=>{
                        if(item.hasRead==false){
                          that.badgeValue++;
                        }
                    })
                }else{
                  that.badgeValue=0;
                } 
            }else{
                this.$message.error(res.data.error_msg)
             }
            })
            .catch(err=>{
              if(err.data && err.data.errorMessages){
                  that.$message.error(err.data.errorMessages[0]);
              }else if(err.data){
                that.$message.error(err.data);
              }
            })
    },
    goMessageCenterPage(){
      this.$router.push('/companyMessage')
    },
    getcompanynamevalue(val){//鼠标移入公司显示tooltip的公司名
      let companyname=''
      this.options.forEach(item=>{
        if(item.enterpriseId===val){
          companyname=item.enterpriseName
        }
      })
      if(companyname.length<13){
        this.disabletoolContent=true
      }else{
        this.disabletoolContent=false
      }
      return companyname
    },
    companyPercenterClick(){//结束header组件传递过来的个人中心按钮点击事件
      console.log(this.$refs.companyHeaderRef.changeMenuByCurrentRole)
      this.$refs.companysidebar.changeMenuByCurrentRole()//根据当前角色进行菜单跳转
    },
    sunadminChange(val){//子管理员切换事件
       this.$store.commit('setCurrentCompany',val)
       window.localStorage.setItem('enterPriseId',val)
       
       this.options.forEach(item=>{//切换企业的时候，查询该账户在该企业的身份
        if(item.enterpriseId===val){
          if(item.isChildAdminUser){//是子管理员
              this.$store.commit('setCompanyLoginRole',false)
          }else{
              this.$store.commit('setCompanyLoginRole',true)
          }
        }
       })
       this.getMenuList()
       this.$refs.companyHeaderRef.reloadcompanyName()
    },
    getMenuList(){
      let that=this;
      this.isRouterShow=false
      this.pageloading=true
      GetMenuListApi()
      .then(res=>{
          if(res.status===200 && res.data.error_code===0){
              this.isRouterShow=true
              this.pageloading=false
              const {data}=res.data
              //再次判断菜单中是否有消息通知
              this.menuReady(data)
              if(data.length){
                  let menuList=this.toTreeData(data)
                  this.checkMenuPath(menuList[0])
              }else{
                  this.$message.error('未获取到当前角色菜单权限！')
              }
          }else{
              this.isRouterShow=false
              this.pageloading=false
              that.$message.error(res.data.error_msg)
          }
      })
      .catch(err=>{
          this.isRouterShow=false
          this.pageloading=false
          this.$message.error('获取到当前角色菜单权限失败！')
          if(err.data && err.data.errorMessages){
              that.$message.error(err.data.errorMessages[0]);
          }else if(err.data){
              that.$message.error(err.data)
          }
      })
  },
   checkMenuPath(menuList){//跳转该菜单的路由
      if(menuList.children.length){
          let menuChildren=menuList.children[0]
          this.checkMenuPath(menuChildren)
      }else{
          this.$router.push(menuList.url)
      }
    },
    GetEnterpriseSelectedList(){//获取当前账户所属企业
      let that=this    
      GetEnterpriseSelectedListApi()
      .then(res=>{
        if (res.status === 200 && res.data.error_code === 0) {
            let {data} = res.data
            data.forEach(item => {
              that.options.push(item)
            })
            that.options.forEach(item=>{
              if(item.enterpriseId===localStorage.getItem('enterPriseId')){
                this.subcompanyvalue=item.enterpriseId
              }
            })
          } else {
            that.$message.error(res.data.error_msg)
          }
      })
      .catch(err=>{
        console.log(err)
        if (err.data && err.data.errorMessages) {
            that.$message.error(err.data.errorMessages[0])
          }else if(err.data){
            that.$message.error(err.data)
          }
      })
    },
    
    toTreeData(data, attr) {//将父子关系的数组转化为树结构
        let tree = []
        let sortArr=data.sort(this.compare('sortNum'));
        sortArr.map(item =>{
            if(Object.prototype.hasOwnProperty.call(item, 'parentId') && item.parentId==null ||item.parentId==''){//是否含有pid，如果没有则是第一层
                let obj=Object.assign({},item)
                obj.children=[]
                tree.push(obj)//把最外层父级push进去
            }
        })
        let res=this.childerData(tree,sortArr)
        return res
    },
    childerData(tree,data){
      for(let i=0;i<tree.length;i++){//循环树形父级元素
          for(let j = 0;j<data.length;j++){//循环数据
          //判断数据的pid是不是等于父级的id，如果是则代表是当前父级的子级
              if(tree[i].menuId == data[j].parentId){
                  let obj=Object.assign({},data[j])
                  obj.children=[]
                  tree[i].children.push(obj)//加入到父级的子级数组中
              }
          }
          this.childerData(tree[i].children,data)//递归调用自己，传入第二层元素 
      }
      return tree
    },
    compare(property){//排序函数,从小到大。
      return function(a,b){
          var value1 = a[property];
          var value2 = b[property];
          return value1 - value2;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
#companymainroute {
  position: relative;
  width: 100%;
  height: 100%;
  .headertrial-bgc{
      height: 260px;
      background-image: url('~@/assets/img/trialCenter/personalCenterbgc.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
      .header-shadow{
          height: 74px;
          background: rgba(0,0,0,0.10);
          width: 100%;
      }
  }
  /deep/ .el-badge__content{
    border: none;
  }
  .ismessagediv{
    display:flex;
    align-items:center;
    margin-right:20px;
    cursor:pointer;position:relative;
  }
  .ismessagehot::before{
      content:'';
      display: inline-block;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background-color: #f56c6c;
      position: absolute;
      top: 8px;
      left: 15px;
    }
}
/deep/ .el-aside {
    background: #ffffff;
    box-shadow: 0 4px 20px -5px rgba(217, 217, 217, 0.5);
    border-radius: 0px;
    padding: 0px 0 20px 0px;
    margin-top: 20px;
}
.content {
  min-height: calc(100% - 380px);
  margin-bottom: 0 !important;
  background-color: #fafafa;
  box-sizing: border-box;
  padding-bottom: 20px;
}
/deep/ .companyselect-wraper{
  .el-input__inner{
    border:1px solid #0069E0 !important;
    background: #0069E0;
    border-radius: 2px;
    color: #fff;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .el-input__suffix{
    .el-select__caret{
      color: #fff !important;
    }
  }
  .el-select-dropdown__item:hover{
    background: #F2F7FF !important;
    color: #4091ff;
  }
}
.companypopper-class{
    max-width: 220px !important;
}

.el-footer {
  padding: 0 0;
}
.el-header {
  padding: 0 0;
}
</style>


// WEBPACK FOOTER //
// src/view/CompanyUser/CompanyMainroute.vue